import { CommonModule, DatePipe } from '@angular/common';
import {
     Component,
     ElementRef,
     EventEmitter,
     HostListener,
     Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import * as moment from 'moment';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
    selector: 'app-formly-calendar-input',
    templateUrl: './calendar.type.component.html',
    styleUrls: ['./calendar.type.component.scss'],
    providers: [DatePipe],
    imports: [DatePickerModule, CommonModule, ReactiveFormsModule, FormsModule],
})
export class FormlyCalendarInputComponent extends FieldType {

    public translatePrefix;

    calendarOptionsOpened = false;
    isDateChanged = false;
    dateRangeLabel: string;
    dateSelected: Date;

    @Output() dateChanged = new EventEmitter();
    constructor(
        public datePipe: DatePipe,
        private eRef: ElementRef,
    ) {
        super();
    }


    toggleCalendar(event) {
        this.calendarOptionsOpened = !this.calendarOptionsOpened;
    }

    setDateRangeLabel() {
        this.dateRangeLabel =
            `${this.datePipe.transform(this.dateSelected, 'dd MMM yyyy')}`;
    }

    customCalendarDatesChanged() {
        this.calendarOptionsOpened = !this.calendarOptionsOpened;
        this.setDateRangeLabel();
        this.isDateChanged = true;
        this.updateDatesInDashboardContext();
    }

    updateDatesInDashboardContext(): void {
        this.dateChanged.emit({
            dateSelected: this.dateSelected,
        });
        this.isDateChanged = false;
      }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.calendarOptionsOpened = false;
        }
    }

}
